import dataSourceCreateReducer from '../components/DataSourceCreateContainer/DataSourceCreateContainer.ducks';
export * from '../components/DataSourceCreateContainer/DataSourceCreateContainer.ducks';
export default dataSourceCreateReducer;

//# sourceMappingURL=DataSourceCreate.ducks.js.map
